import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';

@autoinject
export class CustomerDialog {
  protected customerId: number;

  constructor(protected dialogController: DialogController) {}

  activate(params: { customerId?: number }) {
    if (!params) return;

    this.customerId = params.customerId;
  }

  onCreated(customerId: number) {
    this.dialogController.cancel({ customerId });
  }
}
